import type { Composition, Reference } from '@medplum/fhirtypes'
import { SignatureTask } from '@seen/core/models/tasks/signature/signatureTask'
import { Button } from '@seen/ui'
import { IconArrowLeft } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useNavigate, useParams } from 'react-router'
import { CarePlanHeader } from '#src/components/care-plan/CarePlanHeader.tsx'
import { useCarePlanSnapshotData } from '#src/components/care-plan/useCarePlanSnapshotData.ts'
import { Loader } from '#src/components/core/Loader.tsx'
import { SignatureTable } from '#src/components/signature/SignatureTable.tsx'

export function CarePlanSnapshotSignaturesPage(): JSX.Element {
  const navigate = useNavigate()
  const { carePlanSnapshotId } = useParams()

  const { isLoading, carePlan, signatures, carePlanParticipantSignatures } =
    useCarePlanSnapshotData({
      reference: `Composition/${carePlanSnapshotId}`,
    } satisfies Reference<Composition>)

  if (isLoading || !carePlan) {
    return <Loader />
  }

  return (
    <div>
      <div>
        <CarePlanHeader carePlan={carePlan} activitiesPath="../activities" />
        <div className="mt-10 mb-8 grid grid-cols-3 items-center gap-4">
          <Button onClick={() => navigate(`..`)} variant="outline">
            <IconArrowLeft size={16} className="mr-2" />
            Back to Care Plan
          </Button>
        </div>

        <h2>IDT Convened</h2>

        <div className="flex flex-col gap-4 pt-4">
          <p className="text-md">
            {`${SignatureTask.completedRatio(signatures)} signatures completed.`}
          </p>

          <SignatureTable
            signatures={signatures}
            dateFormat="MM/dd/yy"
            showDiscipline
          />

          <div className="flex flex-col gap-4">
            <h2>Care Plan Review with Participant</h2>
            <SignatureTable
              signatures={carePlanParticipantSignatures}
              dateFormat="MM/dd/yy"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
